import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../_models/api-response.model';
import { TopAgent } from '../../_models/agent.model';
import { PeriodClosure } from '../../_models/period.model';

@Injectable({
  providedIn: 'root'
})
export class PeriodManagementService {
  private apiUrl = `${environment.apiUrl}/admin/period`;

  constructor(private http: HttpClient) {}
  
  getTopAgentsCurrentMonth(): Observable<ApiResponse<TopAgent[]>> {
    return this.http.get<ApiResponse<TopAgent[]>>(`${this.apiUrl}/top-agents/current-month`);
  }

  closeCurrentPeriod(): Observable<ApiResponse<PeriodClosure>> {
    return this.http.post<ApiResponse<PeriodClosure>>(`${this.apiUrl}/close-current`, {});
  }
}